export function TickSVG({
    width = '35',
    height = '27',
    className
}: {
    width?: string;
    height?: string;
    className?: string;
}) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 35 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M32.85 0.558525C20.1922 13.8555 18.621 15.8364 11.2499 23.61L2.80824 15.4765C2.34628 14.9823 1.48678 14.9964 1.03984 15.5056C0.592935 16.0148 0.649159 16.9159 1.15554 17.3595L10.4617 26.3343C10.9205 26.7769 11.7133 26.7581 12.1526 26.2942C20.5074 17.5175 21.3539 16.2542 34.579 2.36131C34.9422 1.98924 35.0467 1.3669 34.8265 0.88679C34.2679 -0.0493687 33.49 0.029225 32.85 0.558269V0.558525Z"
                fill="#0D9876"
            />
        </svg>
    );
}
